import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import moment from 'moment'
import { FieldDatePicker } from '../inputs/date-picker'
import { FieldDropdown } from '../inputs'

const TenancyFieldsContainer = styled.div`
  display: grid;
  grid-template-columns: ${props => (props.showEndDate ? '1fr 1fr 1fr' : '1fr 1fr')};
  gap: 12px;
  padding: 24px;
`

const AdjustedFieldDropdown = styled(FieldDropdown)`
  height: 48px;
`

const TenancyDetails = ({ values, setFieldValue, setFieldTouched }) => {
  const { t } = useTranslation()
  const showEndDate = values.lease_type === 'fixed'
  return (
    <TenancyFieldsContainer showEndDate={showEndDate}>
      <AdjustedFieldDropdown
        id="lease_type"
        name="lease_type"
        placeholder={t('l.contract_edit.lease_terms.lease_type.placeholder', 'Lease Type')}
        onChange={e => {
          setFieldValue('lease_type', e)
          setFieldValue('end_date', null)
          setFieldTouched('end_date', false)
        }}
        options={[
          {
            value: 'fixed',
            label: t('l.listing.edit.fixed_term.text', 'Fixed term')
          },
          {
            value: 'month_to_month',
            label: t('l.listing.edit.month_to_month.text', 'Month to month')
          }
        ]}
      />
      <FieldDatePicker
        name="start_date"
        placeholder={t('l.contract_edit.lease_terms.start_date.placeholder', 'Start date')}
        onChange={e => setFieldValue('start_date', e)}
        maxDate={values.end_date ? moment(values.end_date) : undefined}
      />
      {showEndDate && (
        <FieldDatePicker
          name="end_date"
          placeholder={t('l.contract_edit.lease_terms.end_date.placeholder', 'End date')}
          onChange={e => setFieldValue('end_date', e)}
          disabled={values?.lease_type === 'fixed' ? false : true}
          minDate={values.start_date ? moment(values.start_date) : moment()}
        />
      )}
    </TenancyFieldsContainer>
  )
}

export default TenancyDetails
